var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"limiter"},[_c('div',{staticClass:"container-login100 bg-login"},[_c('div',{staticClass:"wrap-login100 p-l-100 p-r-100 p-t-50 p-b-50"},[(_vm.displayElement == 'login')?[_c('login')]:(_vm.displayElement == 'signup')?[_c('signup')]:(_vm.displayElement == 'recovery-password')?[_c('recovery-password')]:_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b2bd81e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Performance.vue
// module id = null
// module chunks = 